import intlTelInput from "intl-tel-input";
import InputMask from "inputmask";
import "intl-tel-input/build/css/intlTelInput.css";

const intlInputs = document.querySelectorAll('[type="tel"]');

intlInputs.forEach((input) => {
    const iti = intlTelInput(input, {
        preferredCountries: ["ru", "by", "ua", "kz"],
        // utilsScript: "js/modules/plugins/intlTelInputUtils.js",
        initialCountry: "auto",
        geoIpLookup: function (callback) {
            fetch("https://ipapi.co/json")
                .then(function (res) {
                    return res.json();
                })
                .then(function (data) {
                    callback(data.country_code);
                })
                .catch(function () {
                    callback("ru");
                });
        },
        autoInsertDialCode: true,
        separateDialCode: true,
        nationalMode: false,
    });

    iti.promise.then(initMask);
    input.addEventListener("countrychange", initMask);

    function initMask() {
        if (typeof intlTelInputUtils !== "undefined") {
            const selectedCountryData = iti.getSelectedCountryData();

            const newPlaceholder = intlTelInputUtils.getExampleNumber(
                selectedCountryData.iso2,
                false,
                intlTelInputUtils.numberFormat.INTERNATIONAL
            );

            const mask = newPlaceholder.replace(/[0-8]/g, "9").slice(selectedCountryData.dialCode.length + 2);

            const im = InputMask(mask, {
                showMaskOnHover: false,
                showMaskOnFocus: false,
            });

            im.mask(input);
            input.closest('.iti').classList.add('iti--loaded')
            input.disabled = false
        }
    }

});
